import { LoginCallback } from '@okta/okta-react'
import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'
import { AccountSearchResults } from '../../components/AccountSearch'
import { useAuth } from '../../hooks'
import { RoutesEnum } from '../../types/RoutesEnum'
import { setRumSessionUser } from '../../utils/datadog'
import { ApexLogin } from '../ApexLogin'
import AppLayout from '../AppLayout'
import HomePage from '../HomePage'
import TradeEntryPage from '../TradeEntryPage'

export const App = () => {
  const { showAppContent } = useAuth()

  useEffect(() => {
    setRumSessionUser()
  }, [showAppContent])

  return (
    <AppLayout>
      {showAppContent ? (
        <>
          <Route path="/" component={LoginCallback} />
          <Switch>
            <Route path={`/${RoutesEnum.Results}/:searchTerm`}>
              <AccountSearchResults />
            </Route>
            <Route path={`/${RoutesEnum.TradeEntry}/:accountNumber`}>
              <TradeEntryPage />
            </Route>
            <Route path={'/'}>
              <HomePage />
            </Route>
          </Switch>
        </>
      ) : (
        <ApexLogin />
      )}
    </AppLayout>
  )
}
